export enum SurveyType {
  ROUTE_SURVEY = 'route_survey',
  INCIDENT_REPORT = 'incident_report',
  CUSTOMER_FEEDBACK = 'customer_feedback',
}

export interface SurveyTableItem {
  uuid: string;
  accountName: string;
  accountUuid: string;
  type: SurveyType;
  date: string;
  driverName: string;
  driverUuid: string;
  managerOrganizationLevel?: string | null; // Hierarchy node name of the driver's manager, null if manager isnt assigned to a node
  managerName?: string; // Only present for non-driver users
  alertType: string;
  overallScore: number | null;
  enpsScore: number | null;
  commentsCount: number;
  viewed: boolean;
  canMarkAsViewed: boolean;
  categoryScore: number | null; // If category selected
  // Comments shown when showWithCommentsOnly is true. `label` is the route
  // survey category name (or 'eNPS' / 'Incident' / 'Customer Feedback') and
  // `text` is the raw comment.
  comments?: { label: string; text: string }[];
}

export interface PaginatedSurveysResponse {
  data: SurveyTableItem[];
  page: number;
  pageSize: number;
  total: number;
}

export interface DownloadSurveysRequestParams {
  sortBy?: string;
  sortDirection?: string;
  searchText?: string;
  accountUuid?: string;
  dateRange?: string;
  surveyType?: string;
  scoreCategory?: string;
  showAlertsOnly?: boolean;
  showWithCommentsOnly?: boolean;
  showNotViewedOnly?: boolean;
  organizationLevelUuid?: string;
}
